const locale = {
    placeholder: 'Seleccionar hora',
    rangePlaceholder: ["Hora d'inici", 'Hora de fi'],
};
export default locale;
